// extracted by mini-css-extract-plugin
module.exports =  {"layout":"_7a3fb80146--layout--B5Yrh","text":"_7a3fb80146--text--P7YwX","img":"_7a3fb80146--img--luR0a"};